import React, { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SystemControl = lazy(() => import('../pages/admin/SystemControl'));
const WhatsAppSetup = lazy(() => import('../pages/admin/WhatsAppSetup'));

const AdminRoutes = () => {
  const { user } = useAuth();
  const isSuperAdminOrDev = user?.role === 'super_admin' || user?.role === 'developer';

  return (
    <Routes>
      <Route 
        path="system-control" 
        element={isSuperAdminOrDev ? <SystemControl /> : <Navigate to="/" replace />} 
      />
      <Route 
        path="whatsapp" 
        element={isSuperAdminOrDev ? <WhatsAppSetup /> : <Navigate to="/" replace />} 
      />
    </Routes>
  );
};

export default AdminRoutes;
